/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Precheck_NoInputs */



/**
* | output |
* | --- |
* | "No" |
*
* @param {Dialogue_List_Export_Precheck_NoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_precheck_no = /** @type {((inputs?: Dialogue_List_Export_Precheck_NoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Precheck_NoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non")
	if (locale === "de") return /** @type {LocalizedString} */ ("NEIN")
	if (locale === "it") return /** @type {LocalizedString} */ ("NO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет")
	if (locale === "es") return /** @type {LocalizedString} */ ("No")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("不")
	if (locale === "ja") return /** @type {LocalizedString} */ ("いいえ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não")
	return /** @type {LocalizedString} */ ("No")
});